export default "__VITE_ASSET__CPCckOeQ__"